import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-info-currency-exchange-confirmation',
  templateUrl: './info-currency-exchange-confirmation.component.html',
  styleUrls: ['./info-currency-exchange-confirmation.component.scss']
})
export class InfoCurrencyExchangeConfirmationComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
